import type { PasswordValidationRule } from "./PasswordStrengthMeter.types"

export const PASSWORD_VALIDATIONS: PasswordValidationRule[] = [
  { label: "At least 12 characters", validate: (value) => value.length >= 12 },
  { label: "Lowercase letter", validate: (value) => /[a-z]/.test(value) },
  { label: "Uppercase letter", validate: (value) => /[A-Z]/.test(value) },
  { label: "Number", validate: (value) => /[0-9]/.test(value) },
  {
    label: "Symbol",
    validate: (value) => /[^\t\n a-zA-Z0-9]/.test(value),
  },
]

export const getStrengthConfig = (passedCount: number) => {
  if (passedCount <= 1) return { label: "Weak", color: "#ff4d4f" }
  if (passedCount <= 2) return { label: "Fair", color: "#faad14" }
  if (passedCount <= 3) return { label: "Good", color: "#ffc53d" }
  if (passedCount === 4) return { label: "Strong", color: "#52c41a" }
  return { label: "Very Strong", color: "#389e0d" }
}
